import { render, staticRenderFns } from "./MenuTopTemplate.vue?vue&type=template&id=d09c8484&scoped=true&"
import script from "./MenuTopTemplate.vue?vue&type=script&lang=js&"
export * from "./MenuTopTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MenuTopTemplate.vue?vue&type=style&index=0&id=d09c8484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09c8484",
  null
  
)

export default component.exports